import {Component} from '@angular/core';
import {SideNavigationComponent} from "../main/side-navigation/side-navigation.component";
import {Auth} from "@angular/fire/auth";
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from "@angular/material/sidenav";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-page',
  imports: [
    SideNavigationComponent,
    MatDrawer,
    MatDrawerContent,
    MatDrawerContainer,
    RouterOutlet
  ],
  templateUrl: './page.component.html',
  styleUrl: './page.component.css'
})
export class PageComponent {


  constructor(readonly auth: Auth) {
  }
}
